// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2kJ2X","bold":"styles_bold__1PJ9Z","square":"styles_square__yBaZv","inline":"styles_inline__FLIPU"};